import styled from "styled-components";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";
import { IndicatorLayout } from "../consts/indicator-layout";

export const IndicatorDefaultBox = styled.div<{displayLayout?: IndicatorLayout}>`
    display: flex;
    flex-direction: ${({displayLayout}) => displayLayout === IndicatorLayout.List ? "row" : "column" };
    align-items: center;

    position: relative;
    width: ${({displayLayout}) => displayLayout === IndicatorLayout.List ? "auto" : "calc((100% - 1rem) / 2)" };
    padding: ${({displayLayout}) => displayLayout === IndicatorLayout.List ? "1rem 0" : "0.5rem 0" };
    margin: ${({displayLayout}) => displayLayout === IndicatorLayout.List ? "0 1rem" : "0" };
    background: ${({theme, displayLayout}) => displayLayout === IndicatorLayout.List ? "none" : theme.colors.backgroundLight};
    border-top: ${({displayLayout, theme}) => displayLayout === IndicatorLayout.List ? ("1px solid " + theme.colors.boxBorder) : "none" };
    border-radius: 5px;
    cursor: pointer;

    @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
        padding: 0.5rem 0;
    }
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        padding: 1rem 0;
        background: ${({theme}) => theme.colors.backgroundLight}; // componentBackground usefulLinkBackground userMenuSectionBg
    }
`;

const IndicatorCasino777Box = styled(IndicatorDefaultBox)`
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        background: linear-gradient(-45deg, rgba(252,246,213,0.8) 33.33%, rgba(25,50,47,0.1) 33.33%, rgba(25,50,47,0.2) 50%, rgba(252,246,213,0.8) 50%, rgba(252,246,213,0.8) 83.33%, rgba(25,50,47,0.1) 83.33%, rgba(25,50,47,0.1) 100%);
        background-size: 4px 4px;
    }
`;

const IndicatorCasinoMrGreenBox = styled(IndicatorDefaultBox)`
    background: ${({theme}) => theme.colors.backgroundDark};
    box-shadow: inset 0px 0px 5px ${({theme}) => theme.colors.backgroundActive}, inset 0px 0px 10px ${({theme}) => theme.colors.backgroundActive};
    
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        background: ${({theme}) => theme.colors.backgroundDark};
    }
`;

export const IndicatorBox = styledByTheme(IndicatorDefaultBox)
    .forCasino777(IndicatorCasino777Box)
    .forMrGreen(IndicatorCasinoMrGreenBox)
    .apply();
